import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BodyForm = _resolveComponent("BodyForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.lastErrorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.lastErrorMessage), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.isFormAvailable)
      ? (_openBlock(), _createBlock(_component_BodyForm, {
          key: 1,
          onFormReady: _ctx.onFormReady,
          formModel: _ctx.formModel
        }, null, 8 /* PROPS */, ["onFormReady", "formModel"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}